import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Tag} from "primereact/tag";
import axios from "axios";
import {Toast} from "primereact/toast";


const NotfList = props => {
    const toast = useRef(null);
    const [notfList, setNotfList] = useState([]);
    const notfApiPath = "/api/notification/";
    const [globalFilter1, setGlobalFilter1] = useState('');


    useEffect(() => {

        getNotfList()


    }, []); //Buradaki dizi içine yazılan değer, değişince useeffecti çalıştır.

    const customer1TableHeader = (
        <div className="table-header" align="right">

            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)}
                           placeholder="Genel Arama"/>
            </span>
        </div>
    );

    const getNotfList = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch(notfApiPath, {headers,})
                .then(res => {
                    if (res) {
                        if (res.status < 500) {
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            console.log("Server Error!");
                            throw res;
                        }
                    }
                })
                .then(res => {
                    if (res) {
                        if (res.status === 200) {
                            let data = res.data.not_list
                            setNotfList(data);
                        } else if (res.status === 403) {
                            throw res.data;
                        } else if (res.status === 401) {
                            props.loadUser();
                        }
                    }
                })
        }
    }

    const toY3Portal = () => {
        const host = window.location.host;
        if (localStorage.getItem('token')) {
            let url = "https://y3portal.ssyz.org.tr/authorization?token=" + localStorage.getItem('token');
            if (host.includes("localhost"))
                url = "http://localhost:8001/authorization?token=" + localStorage.getItem('token')

            window.location.replace(url);
        } else {
            window.location.replace(host);
            {
                window.location.replace("https://y3.ssyz.org/login");

            }
        }
    }

    const toDegirmenPortal = () => {
        const host = window.location.host;
        if (localStorage.getItem('token')) {
            let url = "https://dportal.ssyz.org.tr/authorization?token=" + localStorage.getItem('token');
            if (host.includes("localhost"))
                url = "http://localhost:8004/authorization?token=" + localStorage.getItem('token')

            window.location.replace(url);
        } else {
            window.location.replace(host);
            {
                window.location.replace("https://degirmen.ssyz.org.tr/login");

            }
        }
    }

    const toMEPortal = () => {
        const host = window.location.host;
        if (localStorage.getItem('token')) {
            let url = "https://meportal.ssyz.org.tr/authorization?token=" + localStorage.getItem('token');
            if (host.includes("localhost"))
                url = "http://localhost:8005/authorization?token=" + localStorage.getItem('token')

            window.location.replace(url);
        } else {
            window.location.replace(host);
            {
                window.location.replace("https://modelegitim.ssyz.org.tr/login");

            }
        }
    }

    const unreadToReadNotf = (notf_id) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        const obj = {
            notf_id: notf_id,

        };
        axios.put('api/unread_to_read_notf' + `/${notf_id}/`, obj, {"headers": headers})
            .then(res => {
                const data = res.data
                if (data.result) {
                    getNotfList()
                    showSuccess(data.message);
                } else {
                    showError(data.message);
                }


            });
    }

    const longNot = (rowData) => {
        let module = rowData.md_id
        if (module === 3) {
            return <div>
                 {rowData.notf_shortnot}

            </div>
        } else if (module === 6) {
            return <div>
                <span dangerouslySetInnerHTML={{__html: rowData['notf_longnot']}}/>
            </div>
        }
    }


    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const actionTemplate = (rowData) => {
        let module = rowData.md_id
        let read_flag = rowData.notf_flag_read
        if (read_flag === true) {
            if (module === 3) {
                return <div>
                    <div>
                        <Button
                            icon="pi pi-circle-off"
                            className="p-button-rounded p-button-info p-button-text"
                            disabled tooltipOptions={{position: 'bottom'}}/>

                        <Button tooltip="Y3 Portale Git" icon="pi pi-arrow-right"
                                onClick={() => toY3Portal()}
                                className="p-button-rounded p-button-info p-button-text"
                                tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
                    </div>

                </div>;
            } else if (module === 5) {
                return <div>
                    <div>
                        <Button
                            icon="pi pi-circle-off"
                            className="p-button-rounded p-button-info p-button-text"
                            disabled tooltipOptions={{position: 'bottom'}}/>

                        <Button tooltip="Değirmen Portale Git" icon="pi pi-arrow-right"
                                onClick={() => toDegirmenPortal()}
                                className="p-button-rounded p-button-info p-button-text"
                                tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
                    </div>

                </div>;
            } else if (module === 6) {
                return <div>
                    <div>
                        <Button
                            icon="pi pi-circle-off"
                            className="p-button-rounded p-button-info p-button-text"
                            disabled tooltipOptions={{position: 'bottom'}}/>

                        <Button tooltip="Model Eğitim Portale Git" icon="pi pi-arrow-right"
                                onClick={() => toMEPortal()}
                                className="p-button-rounded p-button-info p-button-text"
                                tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
                    </div>

                </div>;
            }

        } else {
            if (module === 3) {
                return <div>
                    <div>
                        <Button
                            icon="pi pi-circle-on"
                            className="p-button-rounded p-button-info p-button-text"
                            tooltip="Okundu İşaretle"
                            onClick={() => unreadToReadNotf(rowData['notf_id'])}
                            tooltipOptions={{position: 'bottom'}}/>

                        <Button tooltip="Y3 Portale Git" icon="pi pi-arrow-right"
                                onClick={() => toY3Portal()}
                                className="p-button-rounded p-button-info p-button-text"
                                tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
                    </div>

                </div>;
            } else if (module === 5) {
                return <div>
                    <div>
                        <Button
                            icon="pi pi-circle-off"
                            tooltip="Okundu İşaretle"
                            onClick={() => unreadToReadNotf(rowData['notf_id'])}
                            className="p-button-rounded p-button-info p-button-text"
                            disabled tooltipOptions={{position: 'bottom'}}/>

                        <Button tooltip="Değirmen Portale Git" icon="pi pi-arrow-right"
                                onClick={() => toDegirmenPortal()}
                                className="p-button-rounded p-button-info p-button-text"
                                tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
                    </div>

                </div>;
            } else if (module === 6) {
                return <div>
                    <div>
                        <Button
                            icon="pi pi-circle-on"
                            className="p-button-rounded p-button-info p-button-text"
                            tooltip="Okundu İşaretle"
                            onClick={() => unreadToReadNotf(rowData['notf_id'])}
                            tooltipOptions={{position: 'bottom'}}/>

                        <Button tooltip="Model Eğitim Portale Git" icon="pi pi-arrow-right"
                                onClick={() => toMEPortal()}
                                className="p-button-rounded p-button-info p-button-text"
                                tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
                    </div>

                </div>;
            }
        }


    }

    const moduleTemplate = (rowData) => {
        let status = rowData.md_id
        let color = rowData.md_color
        if (status === 5) {
            return <div>
                <React.Fragment>


                    <Tag className="mr-2" style={{background: color}} value="Değirmen Portal" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === 6) {
            return <div>
                <React.Fragment>

                    <Tag className="mr-2" style={{background: color}} value="Model Eğitim Portal" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === 3) {
            return <div>
                <React.Fragment>

                    <Tag className="mr-2" style={{background: color}} value="Y3 Portal" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === 1) {
            return <div>
                <React.Fragment>

                    <Tag className="mr-2" style={{background: color}} value="Platform" rounded/>


                </React.Fragment>


            </div>;

        }

    }


    {
        return (

            <div>
                <Toast ref={toast}/>
                <div className="datatable-responsive-demo">
                    <div className="card">
                        <h4 style={{textAlign: 'center'}}><b>Tüm Bildirimler</b></h4>
                        <DataTable
                            responsive={true}
                            value={notfList}
                            paginator
                            resizableColumns={true}
                            className="p-datatable-responsive-demo"
                            rows={10} dataKey="id"
                            rowHover globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                            header={customer1TableHeader}

                        >

                            {/*<Column selectionMode="multiple" headerStyle={{width: '3rem'}}></Column>*/}

                            <Column body={longNot}
                                    header="Bildirim İçeriği"
                                    style={{textAlign: 'center', fontWeight: 'bold', width: '15.5em'}}

                            />
                            <Column
                                body={moduleTemplate}
                                header="Portal"
                                style={{textAlign: 'center', fontWeight: 'bold', width: '9.5em'}}


                            />
                            <Column
                                field={'notf_createtime'}
                                header="Bildirim Zamanı"
                                style={{textAlign: 'center', fontWeight: 'bold', width: '9.5em'}}
                                sortable


                            />


                            <Column
                                header="İşlevler"
                                body={actionTemplate}
                                style={{textAlign: 'center', fontWeight: 'bold', width: '7.5em'}}
                            />


                        </DataTable>
                    </div>
                </div>


            </div>

        )
    }

}
const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NotfList);



// WEBPACK FOOTER //
// ./src/pages/notificationmanagement/Notification.jsx